// extracted by mini-css-extract-plugin
export var menuIcon = "_u0-0";
export var menuIconInline = "_u0-1";